import { domainsPath as domainsBasePath } from 'app/constants';
import { QueryKeys, useDeleteDomain } from 'data';
import DeleteModal, { IDeleteModalProps } from '../delete-modal';

export const DomainDeleteModal = ({ entityName, onClose, onSettled }: IDeleteModalProps) => {
  const { mutate: deleteDomain, isLoading: isDomainDeleting } = useDeleteDomain();

  return (
    <DeleteModal
      title="Remove domain?"
      modalText={`Are you sure you want to remove ${entityName} ?`}
      entityName={entityName}
      successMessage={
        <div>
          Domain <strong>{entityName}</strong> was removed
        </div>
      }
      redirectPath={domainsBasePath}
      queryKey={QueryKeys.DOMAINS}
      deleteMethod={deleteDomain}
      onClose={onClose}
      onSettled={onSettled}
      isLoading={isDomainDeleting}
    />
  );
};
